import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-simple-page',
  standalone: true,
  template: `
    <div class="page-header">
      <div>
        <h2>{{ title }}</h2>
        <p>This module shell is ready for workflow-specific forms, tables, filters, and exports.</p>
      </div>
    </div>
    <article class="panel">
      <h3>Module Roadmap</h3>
      <ul class="activity-list">
        <li>Search, filters, pagination, and role-aware actions.</li>
        <li>Audit fields and soft delete support through the API.</li>
        <li>Excel/PDF export hooks for reporting screens.</li>
      </ul>
    </article>
  `
})
export class SimplePageComponent {
  private readonly route = inject(ActivatedRoute);
  readonly title = this.route.snapshot.data['title'] ?? 'Module';
}
